import { withCompInfo } from '@wix/editor-elements-integrations'
import { MenuContainerCSS, MenuContainerDefinition } from './MenuContainer'
import { CompInfo } from '@wix/thunderbolt-components-native'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'

interface GetNonResponsiveCssProps {
	compLayout: CompInfo['compLayout']
	siteWidth: number
	fillLayersCSSVars: any
	isOneDocMigrated?: boolean
}

const getNonResponsiveCss = ({
	compLayout,
	siteWidth,
	fillLayersCSSVars,
	isOneDocMigrated,
}: GetNonResponsiveCssProps) => {
	if (isOneDocMigrated) {
		return fillLayersCSSVars
	}

	const docked = compLayout.docked
	const horizontallyStretched = docked?.left && docked?.right

	const position = `calc((100% - ${siteWidth}px) / 2)`

	const horizontallyDockedAndNotStretchedCss =
		(!horizontallyStretched &&
			docked?.right && {
				right: position,
			}) ||
		(docked?.left && {
			left: position,
		})

	return { ...horizontallyDockedAndNotStretchedCss, ...fillLayersCSSVars }
}

export const css = withCompInfo<MenuContainerCSS, MenuContainerDefinition>()(
	[
		'hasResponsiveLayout',
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'compLayout',
		'compId',
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		'siteWidth',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		'siteWidth',
		'isOneDocMigrated',
	],
	({
		hasResponsiveLayout,
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		compLayout,
		compId,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		siteWidth,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
		isOneDocMigrated,
	}) => {
		const backgroundMedia = compDesign?.background || {}
		const fillLayersCSSVars = getFillLayersCSSVars({
			animations,
			backgroundMedia,
			compDesign,
			compProps,
			compId,
			experiments,
			isMobileView,
			isNonAdaptiveMobile,
			siteColors,
			viewMode,
		})
		return hasResponsiveLayout
			? {}
			: getNonResponsiveCss({
					compLayout,
					siteWidth,
					fillLayersCSSVars,
					isOneDocMigrated,
			  })
	}
)
